module.exports = __webpack_public_path__ + "img/emoji_20.01846592.png";